import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { activeLanguagesBackend } from './active-languages.backend';
import { activeLanguagesReducer } from './active-languages.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('activeLanguages', activeLanguagesReducer),
    BackendModule.forFeature('activeLanguages', activeLanguagesBackend),
  ],
})
export class DatastoreActiveLanguagesModule {}
